import { render, staticRenderFns } from "./AuthOperationButtons.vue?vue&type=template&id=240e3e5a"
import script from "./AuthOperationButtons.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthOperationButtons.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports